<script lang="ts">
    interface Props {
        name: string;
    }

    let { name }: Props = $props();
</script>

{#if name}
    <span class="reptile-product-title">{name}</span>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/mixins';

    .reptile-product-title {
        display: inline;

        font-family: 'OttoSansMedium', tokens.$oc-semantic-font-copy-font-family;
        font-size: tokens.$oc-base-font-size-87;
        font-weight: 500;
        line-height: tokens.$oc-base-font-line-height-125;

        @include mixins.text-clamp(2);
    }
</style>
